// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { projectBillingInfoSchema } from '@/project/api/types';
import { z } from 'zod';

const projectBillingInfoResponseSchema = z.object({
  data: projectBillingInfoSchema,
  metadata: responseMetadataSchema,
});

type ProjectBillingInfoResponse = z.infer<
  typeof projectBillingInfoResponseSchema
>;

/**
 * Fetches the narrow billing fields for a single project. Used by the
 * invoice edit dialog to coalesce customer fields against project overrides.
 */
export async function getProjectBillingInfo(
  projectKey: string
): Promise<ProjectBillingInfoResponse> {
  const url = `/v1/project/${projectKey}/billing-info`;
  const response = await api.get(url);
  return parseResponse(projectBillingInfoResponseSchema, response.data, {
    schemaName: 'ProjectBillingInfo',
    endpoint: url,
  });
}
